import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/users")({
  component: lazyRouteComponent(() => import("@/pages/admin/Users")),
});
